app.config(function ($translateProvider) {
    $translateProvider.translations('en-gb', {
        DEPARTMENT_LIST: 'Departments',
        DEPARTMENT_ADD: 'Add a new Department',
        ABSENCE_APPROVER: 'Absence Approver',
        DEPARTMENT_EDIT: 'Edit Department',
        TIMESHEET_APPROVER: 'Timesheet Approver'
    });
});
